import { useEffect, useState } from "react";
import { MdArrowUpward } from "react-icons/md";

export default function ScrollTopButton() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const nextProgress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      setProgress(Math.max(0, Math.min(100, nextProgress)));
      setVisible(scrollTop > 160);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <button
      type="button"
      className="vex-scroll-top"
      data-visible={visible}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      style={{ "--scroll-progress": `${progress}%` }}
      aria-label="Scroll to top"
    >
      <span className="vex-scroll-top-core">
        <MdArrowUpward />
      </span>
    </button>
  );
}
